import { render, staticRenderFns } from "./Yjql.vue?vue&type=template&id=0aa5fc1f&scoped=true"
import script from "./Yjql.vue?vue&type=script&lang=js"
export * from "./Yjql.vue?vue&type=script&lang=js"
import style0 from "./Yjql.vue?vue&type=style&index=0&id=0aa5fc1f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa5fc1f",
  null
  
)

export default component.exports